// Package imports:
import React from 'react';
import { format } from 'date-fns';
import isIsLocale from 'date-fns/locale/is';

interface IProps {
    date: Date,
    highlighted?: boolean,
};

const CalendarDate: React.FC<IProps>= ({date, highlighted}) => {
    return (
        <div className="KCL_calendarDate">
            {highlighted
                ? (
                    <div className="highlighted_date">
                        <span>{format(date, 'd')}</span>
                        <strong>{format(date, 'MMM', { locale: isIsLocale })}</strong>
                    </div>
                )
                : (
                    <span>{format(date, 'dd.MMM', { locale: isIsLocale })}</span>
                )
            }
        </div>
    );
}

export default CalendarDate;